import { defineStore } from 'pinia';
// import type { IState } from '@common/store/interface';
import { apiZhUrl } from '@/http/api';
import { jsbTouchEvent, schemaSingle, jsbSupportMap, jsbGetDeviceIds, openWebview, jsbSupportShareSceneMap, jsbShare, schemaSupportMap, schemaToPostPublish } from '@q-front-npm/jsbridge';
import { useStoreCommon } from '@common/store/common';
import axios from 'axios';
import Vue from 'vue';
import prizeAva1 from '@/assets/images/prize_ava1.png';
import prizeAva2 from '@/assets/images/prize_ava2.gif';

export const useStore = defineStore('store', {
    state: () => {
        return {
            pageData: {
                activity_status: '',
            } as Record<string, any>,
            popStatus: {
                // 可以动态添加其他pop状态
                imgView: false,
                code: false,
            } as Record<string, boolean>,
            // TODO from需要找产品要
            bookFriendDetail: {
                topicId: '411919',
                topicTitle: '',
                topicContent: '',
                books: [ // 关联书籍
                    // { id: '215243', type: '0', }// 书籍
                ],
                from: '1', // 来源标识
            },
            currentTab: '1', // 当前tab
            // TODO 问产品要跳转更多书籍链接
            bookListUrl: 'https://xiaoshuo.wtzw.com/h5/activity/freereaderWishBooks/sidePanel/book-list?full_screen=3',
            // isInstallWeiBo: false,
            prizePopData: {
                show: false,
                data: [],
            },
            systemNoticePrivilege: false,
            zhJsonUrl: {},
            prizeImg: [prizeAva1, prizeAva2],
            isInputFocus: false,
            isNeedFocus: false, // 标识 某些原因导致的失去焦点事件无效
            topicList: [
                {topicId: '414753', topicTitle: '意难平拯救计划',},
                {topicId: '414754', topicTitle: '向全七猫安利你',},
            ],
            showPageLoading: false,
        };
    },
    actions: {
        setPopStatus(key: string, value: boolean) {
            jsbTouchEvent(value ? true : false);
            this.popStatus[key] = value;
        },
        setPageData(data: Record<string, any>) {
            this.pageData = { ...this.pageData, ...data, };
        },
        setCurrentTab(value: string) {
            this.currentTab = value;
        },
        setPrizePopData(data: Record<string, any>) {
            console.log('setPrizePopData', data);
            this.prizePopData = { ...this.prizePopData, ...data, };
        },
        getSystemNoticePrivilege() {
            schemaSingle.runSchema('push_permission', { type: '2',}, status => {
                console.log('-- native notice status', status);
                this.systemNoticePrivilege = status == 1;
            });
        },
        setIsInputFocus(value: boolean) {
            this.isInputFocus = value;
        },
        setIsNeedFocus(value: boolean) {
            this.isNeedFocus = value;
            if (value) {
               setTimeout(() => {
                this.isNeedFocus = false;
               }, 1000);
            }
        },
        async getZhUrl(isNeedRefresh: boolean = false) {
            if (!isNeedRefresh && !this.zhJsonUrl) return;

            const storeCommon = useStoreCommon();
            let deviceJson = {};
            console.log('-----------------jsbSupportMap.app.deviceIds', jsbSupportMap.app.deviceIds);
            if (jsbSupportMap.app.deviceIds && !storeCommon.systemInfo.isHarmony) {
                console.log('-----------------jsbGetDeviceIds');
                deviceJson = await jsbGetDeviceIds().catch(() => {console.log('-----------------jsbGetDeviceIds error');});
                console.log('-----------------deviceJson', deviceJson);
            }
            const res = await apiZhUrl({
                platform: storeCommon.systemInfo.isIos ? '2' : '1',
                data: JSON.stringify(deviceJson),
            }).catch(() => {});
            if (res?.errors) return;
            this.zhJsonUrl = {...this.zhJsonUrl, ...res};
        },
        // type 1: 阅读器 2： 活动页
        async goToZh(type: number, data: Record<string, any> = {}) {
            await this.getZhUrl(true);


            // 一些要求int的参数需要转换
            const intParams = ['bid', 'cid', 'pt'];

            // 纵横归因请求
            if (this.zhJsonUrl?.url) {
                const params = this.zhJsonUrl?.body_data || {};
                if (type === 1) {
                    params.bid = data.zh_id;
                    params.cid = data.zh_chapter_id;
                }
                intParams.forEach(key => {
                    if (params[key]) {
                        params[key] = +params[key];
                    }
                });
                axios.post(this.zhJsonUrl.url, params).catch(() => {});
            }

            const storeCommon = useStoreCommon();

            const platformUrl = {
                'ios': 'zongheng://ios/appjumplink?actionKey=',
                'android': 'zongheng://com.zongheng/zhProtocol?zhProtocolUrl=',
            }
            const dataJson = {
                id: type == 1 ? '19' : '1',
                ...(this.zhJsonUrl?.p_data || {}),
            }
            // 阅读器
            if (type == 1) {
                dataJson.bookId = data.zh_id;
                dataJson.chapterId = data.zh_chapter_id;
            }
            // 活动页
            if (type == 2) {
                dataJson.url = encodeURIComponent(import.meta.env.VITE_ENV !== 'production'
                    ? 'https://newspro.xmkanshu.cn/marketing/816?zong_heng_share_bool=1'
                    :`https://newspro.zongheng.com/marketing/816?zong_heng_share_bool=1`);
            }
            let urlstr = 'zh://?';
            Object.keys(dataJson).forEach((key, index) => {
                if (dataJson[key as keyof typeof dataJson]) {
                    urlstr += `${key}=${intParams.includes(key) ? +dataJson[key] : dataJson[key]}${index !== Object.keys(dataJson).length - 1 ? '&' : ''}`;
                }
            });
            console.log('-----------------urlstr');
            console.log(storeCommon.systemInfo.isIos
                ? `${platformUrl.ios}${encodeURIComponent(urlstr)}`
                : `${platformUrl.android}${encodeURIComponent(urlstr)}`);

            const url = storeCommon.systemInfo.isIos
                ? `${platformUrl.ios}${encodeURIComponent(urlstr)}`
                : `${platformUrl.android}${encodeURIComponent(urlstr)}`;

            this.showPageLoading = true;
            if (storeCommon.systemInfo.isIos) {
                schemaSingle.openSchema(`freereader://open_app_or_appstore?param={"url":"${url}","itms_apps":"itms-apps://itunes.apple.com/app/id433125283"}`);
            } else {
                window.open(url,'_blank');
            }
            // window.open(
            //     storeCommon.systemInfo.isIos
            //         ? `${platformUrl.ios}${encodeURIComponent(urlstr)}`
            //         : `${platformUrl.android}${encodeURIComponent(urlstr)}`,
            //     '_blank');
            let jumpFn = null;
            jumpFn = setTimeout(() => {
                console.log('-----------------jumpDown', storeCommon.systemInfo.isIos ? 'https://apps.apple.com/cn/app/zong-heng-kan-xiao-shuo/id433125283?mt=8' : 'market://details?id=com.zongheng.reader');
                storeCommon.systemInfo.isIos
                    ? openWebview(`https://apps.apple.com/cn/app/zong-heng-kan-xiao-shuo/id433125283?mt=8`)
                    : window.open(`market://details?id=com.zongheng.reader`, '_self');
                jumpFn = setTimeout(() => {
                    openWebview('https://m.zongheng.com/appinfo?zhProtocolUrl=');
                    jumpFn = null;
                    this.showPageLoading = false;
                }, 2000);
            }, 3000);
            document.addEventListener('visibilitychange', () => {
                if (!!jumpFn) {
                    clearTimeout(jumpFn);
                    this.showPageLoading = false;
                }
            });
        },
        async goToTopic(topicInfo: Record<string, any>) {
            const storeCommon = useStoreCommon();
            if (storeCommon.systemInfo.isHarmony) {
                if (!jsbSupportShareSceneMap.bookFriend) {
                    Vue.prototype.$toast('请升级至最新版本参与活动');
                    return;
                }
                jsbShare(
                    {
                        scene: 13, // 书友圈
                        topicId: topicInfo.topicId,
                        topicTitle: topicInfo.topicTitle,
                        topicContent: '',
                        books: [],
                        from: '1', // 来源标识
                    });
                return;
            }

            if (!schemaSupportMap.image_text_post_publish) {
                Vue.prototype.$toast('请升级至最新版本参与活动');
                return;
            }
            schemaToPostPublish({
                from: '1',
                topic_id: topicInfo.topicId,
                topic_title: topicInfo.topicTitle,
            });
        },
    },
    getters: {
        pendantImgurl: ((state) => {
            // const id = state.pageData?.claim_pendant_id || '';
            // return id && +id !== 0
            //     ? state.pageData?.pendant_list?.find(item => item.id === id)?.img_url || ''
            //     : state.pageData?.pendant_list?.find(item => item.name.includes('铁马'))?.img_url || '';
        }),
    },
});
